import {
  createContext,
  useMemo,
  useContext,
  useEffect,
  ReactNode,
} from 'react';
import io, { Socket } from 'socket.io-client';

const server = 'http://localhost:7500';

type SocketContextType = Socket | null;

const SocketContext = createContext<SocketContextType>(null);

const useGetSocket = (): Socket => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error('Socket must be used within a SocketProvider');
  }
  return context;
};

type SocketProviderProps = {
  children: ReactNode;
};

const SocketProvider: React.FC<SocketProviderProps> = ({ children }) => {
  const socket = useMemo(
    () =>
      io(server, {
        transports: ['websocket', 'polling'],
        withCredentials: true,
      }),
    [],
  );

  useEffect(() => {
    // Log connection events
    socket.on('connect', () => {
      console.log(`Connected to server with ID: ${socket.id}`);
    });

    socket.on('disconnect', () => {
      console.log('Disconnected from server');
    });

    // Handle connection errors
    socket.on('connect_error', err => {
      console.error('Connection error:', err);
    });

    // Cleanup the socket connection on unmount
    return () => {
      socket.disconnect();
    };
  }, [socket]);

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
};

export { SocketProvider, useGetSocket };
